<template>
    <form action="" autocomplete="off" method="POST" id="newsletterForm">
        <div aria-hidden="true" style="position: absolute; left: -5000px;">
            <input type="text" name="b_63e4fde2e4b46c62fddbac02c_870a1cf0d2" tabindex="-1" value="">
        </div>
        <span class="w-full flex flex-col relative mt-20 text-white">
            <button @click="checkForm" type="button" class="absolute bottom-2.5 rounded-full bg-white/20 hover:bg-white right-3 w-[40px] h-[40px] flex items-center justify-center transition-all">
                <svg class="text-primary-400" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="21.414px" height="15.683px" viewBox="0 0 21.414 15.683" enable-background="new 0 0 21.414 15.683" xml:space="preserve">
                    <g>
                        <line fill="none" stroke="currentColor" stroke-miterlimit="10" x1="0" y1="7.841" x2="20.715" y2="7.841"/>
                        <polyline fill="none" stroke="currentColor" stroke-miterlimit="10" points="13.219,0.354 20.707,7.841 13.219,15.329 	"/>
                    </g>
                </svg>
            </button>
            <input @focus="validation.email.state = null" class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl peer" placeholder=" " id="email" name="EMAIL" type="email" v-model="form.email" />
            <label class="text-white text-xxs absolute left-3 -top-4 font-alternate tracking-[3px] opacity-50 pointer-events-none peer-focus:!text-xxs peer-focus:-top-4 peer-placeholder-shown:text-sm peer-placeholder-shown:xl:text-xbase peer-placeholder-shown:top-0 transition-all">
                {{$root.translateString('newsletter-label')}}
            </label>
        </span>
        <span v-if="validation.email.state != null" class="text-red-400 px-1.5 text-xxs uppercase font-alternate flex items-center mt-2">
            {{ validation.email.message }}
        </span>
        <span class="flex w-full justify-center items-center space-x-3 mt-6">
            <span class="w-[30px] h-[30px] relative block">
                <input @click="validation.privacy.state = null" name="footer-privacy" id="footer-privacy" class="absolute top-0 left-0 w-full h-full opacity-0 accent-transparent outline-none ring-0" type="checkbox" v-model="form.privacy">
                <span class="fake-checkbox absolute top-0 left-0 w-full h-full pointer-events-none bg-no-repeat bg-center border border-white/50"></span>
            </span>
            <label for="footer-privacy" class="cursor-pointer">
                <span class="text-white/50 text-lg lg:text-xl">
                    {{$root.translateString('accept')}}
                </span>
                <a class="underline text-white/50 hover:text-white/100 text-xl transition-all" :href="'/' + lang + '/privacy-policy'">
                    {{$root.translateString('link')}}
                </a>
            </label>
        </span>
        <span v-if="validation.privacy.state != null" class="text-red-400 px-1.5 text-xxs uppercase font-alternate flex items-center justify-center mt-2">
            {{ validation.privacy.message }}
        </span>
    </form>
</template>

<script>
    export default {

        props: ['lang'],

        data() {
            return {
                error: false,
                sending: false,
                validator: null,
                form: {
                    email: '',
                    privacy: false
                },
                validation: {
                    email: {
                        state: null,
                        message: '',
                    },
                    privacy: {
                        state: null,
                        message: '',
                    },
                },
            }
        },
        methods: {

            checkForm() {

                this.sending = true;
                let error = false;

                Object.keys(this.validation).forEach(key => {
                    this.validation[key].state = null;
                });

                if(this.form.name == '') {
                    this.validation.name.message = this.$root.translateString('form-mandatory');
                    this.validation.name.state = false;
                    error = true;
                }

                if(this.form.surname == '') {
                    this.validation.surname.message = this.$root.translateString('form-mandatory');
                    this.validation.surname.state = false;
                    error = true;
                }

                if(this.form.email == '') {
                    this.validation.email.message = this.$root.translateString('form-mandatory');
                    this.validation.email.state = false;
                    error = true;
                }

                if(!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.form.email))) {
                    this.validation.email.message = this.$root.translateString('form-format');
                    this.validation.email.state = false;
                    error = true;
                }

                if(this.form.country == '') {
                    this.validation.country.message = this.$root.translateString('form-mandatory');
                    this.validation.country.state = false;
                    error = true;
                }

                /*if(this.form.phone && this.form.phone != '' && !(/^[+()\d-]+$/.test(this.form.phone))) {
                    this.validation.phone.message = 'Il campo non è nel formato corretto.';
                    this.validation.phone.state = false;
                    error = true;
                }*/

                if(this.form.privacy === false) {
                    this.validation.privacy.message = this.$root.translateString('form-mandatory');
                    this.validation.privacy.state = false;
                    error = true;
                }

                if(!error) {
                    this.validator = '64Tg6Jhx!z_';
                    this.sendMail()
                }else{
                    this.sending = false;
                }

            },

            sendMail() {

                if(this.validator == '64Tg6Jhx!z_') {

                    document.querySelector('#newsletterForm').submit();

                }else{

                    return false

                }



            }

        }
    }
</script>

<style lang="scss" scoped>

</style>
